// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#card-errors[data-v-1150a088] {\n  color: #fa755a;\n  display: grid;\n  align-items: center;\n  text-align: center;\n}\n\n", ""]);
// Exports
module.exports = exports;
